export default "__VITE_ASSET__DQhAd6Ak__"